// extracted by mini-css-extract-plugin
export default {"popup":"tYAsO"};